import type { AfterViewInit } from '@angular/core'
import { ChangeDetectionStrategy, Component, output, viewChild, inject, input, signal } from '@angular/core'
import { ButtonComponent } from '../../buttons/button/button.component'
import { ModalComponent } from '../../layout/modal/modal.component'
import { Size } from '@awork/_shared/types/size'
import { Color } from '@awork/_shared/types/color'
import { LinkButtonComponent } from '../../buttons/link-button/link-button.component'
import { FrontendMetric, MetricsService } from '@awork/_shared/services/metrics-service/metrics.service'
import { BrowserService } from '@awork/_shared/services/browser-service/browser.service'

@Component({
  selector: 'aw-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, ButtonComponent, LinkButtonComponent]
})
export class ErrorModalComponent implements AfterViewInit {
  private browserService = inject(BrowserService)
  private metricsService = inject(MetricsService)

  readonly error = input<Error>()
  readonly shakeDuration = input<number>()
  readonly eventId = input<string>()

  hiding = output<void>()
  showing = output<void>()

  readonly modal = viewChild<ModalComponent>('modal')

  readonly showDetails = signal<boolean>(false)

  protected translations = {
    ...q.translations.ErrorModalComponent,
    contactSupport: q.translations.MainMenuComponent.startChat,
    close: q.translations.common.close
  }
  protected readonly Size = Size
  protected readonly Color = Color

  /**
   * Waits for the shake duration and shows the modal.
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.modal() && this.modal().show) {
        this.show()
      }
    }, this.shakeDuration() || 0)
  }

  /**
   * Shows the modal and emits the showing event.
   */
  show() {
    this.trackShakyToastShown()
    this.modal().show()
    this.showing.emit()
  }

  /**
   * Hides the modal and emits the hiding event.
   */
  hide() {
    this.modal().hide()
    this.hiding.emit()
  }

  /**
   * Reloads the current page.
   */
  reload() {
    window.location.reload()
  }

  /**
   * Opens the support chat and closes the modal.
   */
  onContactSupportClick(): void {
    this.hide()
    this.browserService.showSupportChat()
  }

  /**
   * Sends the shaky toast metric to the backend.
   */
  private trackShakyToastShown(): void {
    this.metricsService.incrementMetric(FrontendMetric.ShakyToastShown, 1).subscribe()
  }
}
